import React from 'react';
import CampoEditableTexto from '../../../UI/campos/CampoEditableTexto.js';
import CampoCheckEditable from '../../../UI/campos/CampoEditableCheck.js';
import * as TipoEdicion from '../../../constantes/TipoEdicion.js';
import styles from '../Parametros.module.css';
import CampoEditableNumero from '../../../UI/campos/CampoEditableNumero.js';

const campos = {
  CODIGO: 'codigo',
  DESCRIPCION: 'descripcion',
  TRIBUNAL: 'tribunal',
};

const CamposTipoResultado = (props) => {
  const parametro = props.parametro;
  const tipoEdicion = props.tipoEdicion;

  const onCampoChange = (nombre, valor) => {
    switch (nombre) {
      case campos.CODIGO: {
        props.onCampoChange({ ...parametro, codigo: valor });
        break;
      }
      case campos.DESCRIPCION: {
        props.onCampoChange({ ...parametro, descripcion: valor });
        break;
      }
      case campos.TRIBUNAL: {
        props.onCampoChange({ ...parametro, tribunal: valor });
        break;
      }
      default:
    }
  };

  return (
    <React.Fragment>
      <table className={`${styles.tablaDatos}`}>
        <tbody>
          <tr>
            <td className={`${styles.titulo}`}>Código</td>
            <td className={`${styles.valor}`}>
              <CampoEditableNumero
                nombre={campos.CODIGO}
                valor={parametro && parametro.codigo}
                editar={tipoEdicion === TipoEdicion.ALTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Descripción</td>
            <td className={`${styles.valor}`}>
              <CampoEditableTexto
                nombre={campos.DESCRIPCION}
                valor={parametro && parametro.descripcion}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
          <tr>
            <td className={`${styles.titulo}`}>Tribunal</td>
            <td className={`${styles.valor}`}>
              <CampoCheckEditable
                nombre={campos.TRIBUNAL}
                checked={parametro && parametro.tribunal}
                editar={tipoEdicion !== TipoEdicion.CONSULTA}
                onChange={onCampoChange}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default CamposTipoResultado;
